import { Validator } from '@vista-digital/validator';
import { headingLevels } from '../../../../subcomponents/heading/heading';
import { defaultFilmTitleCdnOptions, filmTitleCdnOptionsValidator } from './cdn-options';
export const defaultFilmTitleProps = {
    as: 'h1',
    cdnOptions: defaultFilmTitleCdnOptions
};
export const filmTitlePropsValidator = Validator.any([
    Validator.object({
        as: Validator.oneOf([...headingLevels, 'span', 'div', 'p']),
        cdnOptions: filmTitleCdnOptionsValidator
    })
]);
//# sourceMappingURL=props.js.map